<template>
  <div id="drawer" style="display: contents">
    <v-navigation-drawer
      id="side-bar"
      v-model="drawer"
      :mini-variant="mini"
      mini-variant-width="80"
      class="show-overflow h-100"
      stateless
      permanent
      app
    >
      <div v-if="this.isGuidedTutorialParamOrbitTranfer1andTimeToStart">
        {{ this.startGuidedTutorialParamOrbitTransfer1() }}
      </div>
      <div gt_ParamOrbitTransfert1-v-step="20"></div>
      <div gt_ParamOrbitTransfert1-v-step="21"></div>
      <div
        v-if="this.gt_OrbitTransferParam1.orbitsTourDone"
        gt_ParamOrbitTransfert1-v-step="29"
      ></div>
      <v-toolbar flat text class="position-center" giveMeATour-v-step="9">
        <v-list class="pa-0 w-100">
          <v-list-item class="no-padding">
            <div v-if="mini">
              <v-btn
                color="info"
                icon
                class="mr-0 ml-0"
                @click.stop="mini = !mini"
              >
                <v-icon class="grey--text">chevron_right</v-icon>
              </v-btn>
            </div>
            <div v-if="!mini">
              <v-tooltip
                top
                nudge-bottom="30"
                nudge-right="230"
                :disabled="mini"
              >
                <template v-slot:activator="{ on }">
                  <v-list-item-content v-on="on" class="pl-4">
                    <v-list-item-title class="grey--text name-width"
                      >{{ currentMission.name.toUpperCase().slice(0, 13) }}
                      <span
                        class="grey--text"
                        v-if="currentMission.name.length > 13"
                        >...</span
                      >
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <span>{{ currentMission.name }}</span>
              </v-tooltip>
            </div>
            <div v-if="!mini">
              <v-btn
                color="info"
                icon
                class="mr-0 ml-0"
                @click.stop="mini = !mini"
              >
                <v-icon class="grey--text">chevron_left</v-icon>
              </v-btn>
            </div>
          </v-list-item>
        </v-list>
      </v-toolbar>
      <v-list class="p-2" dense>
        <v-list-item
          v-for="link in paths"
          :id="getPathId(link)"
          :key="link.title"
          @click="changeRoute(link)"
          :class="SelectedOrNotClass(link)"
        >
          <v-tooltip right :disabled="!mini">
            <template v-slot:activator="{ on }">
              <v-list-item-action
                v-if="mini"
                v-on="on"
                class="grey--text lighten-5"
              >
                <icon
                  scale="1.5"
                  :name="link.icon"
                  :class="{ selectedItem: link.path === currentPath }"
                />
              </v-list-item-action>
              <v-list-item-action
                v-else
                v-on="on"
                class="grey--text lighten-5 long-list-margin"
              >
                <icon
                  scale="1.5"
                  :name="link.icon"
                  :class="{ selectedItem: link.path === currentPath }"
                />
              </v-list-item-action>
            </template>
            <span>{{ link.title }}</span>
          </v-tooltip>
          <v-list-item-content class="text">
            <v-list-item-title
              :class="{ selectedItem: link.path === currentPath }"
              >{{ link.title }}</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-tour
      name="sideBarTour"
      :steps="steps"
      :callbacks="customTourCallbacks"
    ></v-tour>
    <v-tour
      name="paramOrbitalTransfer1TourSideBar"
      :steps="steps_side_navigation"
      :callbacks="customSideNavCallbacks"
      :options="noSkipStepOption"
    ></v-tour>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import guidedTutorialParamOrbitalTransfer1, {
  steps_side_navigation
} from '../components/GuidedTutorials/guidedTutorialParamOrbitalTransfer1.js'
import { noSkipStepOption } from '../components/GuidedTutorials/guidedTutorialConstraints.js'

export default {
  name: 'side-menu-bar',
  mounted: function () {
    this.$root.$on('current-mission-updated', this.currentMissionUpdatedHandler)
    this.$root.$on('current-results-updated', this.currentResultsUpdatedHandler)
    if (this.giveMeATour) {
      this.$tours['sideBarTour'].start()
    }
  },

  beforeDestroy() {
    this.$root.$off(
      'current-mission-updated',
      this.currentMissionUpdatedHandler
    )
    this.$root.$off(
      'current-results-updated',
      this.currentResultsUpdatedHandler
    )
  },

  computed: {
    ...mapGetters([
      'currentMission',
      'currentResultsLog',
      'giveMeATour',
      'gt_OrbitTransferParam1'
    ]),

    isGuidedTutorialParamOrbitTranfer1andOrbitTourDone() {
      return this.gt_OrbitTransferParam1.orbitsTourDone
    },

    isGuidedTutorialParamOrbitTranfer1andTimeToStart() {
      return (
        this.gt_OrbitTransferParam1.isActive &&
        this.gt_OrbitTransferParam1.secondMissionTourDone
      )
    }
  },
  data() {
    const self = this
    return {
      drawer: true,
      mini: true,
      currentPath: this.$router.currentRoute.path,
      paths: this.getItems(),
      steps_side_navigation: steps_side_navigation,
      noSkipStepOption: noSkipStepOption,
      steps: [
        {
          target: '[giveMeATour-v-step="9"]',
          content:
            'Use the <strong>side bar</strong> to create all the necessary <strong>objects</strong> for your mission.'
        }
      ],
      customTourCallbacks: {
        onFinish: () => {
          self.$router.push('/analyticalorbit')
        }
      },
      customSideNavCallbacks: {
        onNextStep: (currentStep) => {
          guidedTutorialParamOrbitalTransfer1.onNextStepSideNav(
            currentStep,
            this,
            self
          )
        },
        onSkip: () => {
          guidedTutorialParamOrbitalTransfer1.stopAllTours(this)
        },
        onFinish: () => {
          self.$router.push('/analyticalmission')
        }
      }
    }
  },
  methods: {
    ...mapActions(['start_gt_OrbitTransferParam1']),

    currentMissionUpdatedHandler() {
      this.paths = this.getItems()
    },
    currentResultsUpdatedHandler() {
      this.paths = this.getItems()
    },

    SelectedOrNotClass(link) {
      if (link.path === this.currentPath) {
        if (this.$vuetify.theme.dark === false) {
          return ['grey lighten-2', 'tile']
        } else {
          return ['tile-darkMode']
        }
      } else {
        if (this.$vuetify.theme.dark === false) {
          return 'tile'
        } else {
          return 'tile-darkMode'
        }
      }
    },
    startGuidedTutorialParamOrbitTransfer1() {
      if (this.gt_OrbitTransferParam1.isActive) {
        if (
          !this.gt_OrbitTransferParam1.firstSideNavTourDone &&
          this.$router.currentRoute.path === '/analyticalmission'
        ) {
          this.$tours['paramOrbitalTransfer1TourSideBar'].start()
        } else if (
          !this.gt_OrbitTransferParam1.orbitsTourDone &&
          this.gt_OrbitTransferParam1.firstSideNavTourDone &&
          this.$router.currentRoute.path === '/analyticalspacecraft'
        ) {
          this.$tours['paramOrbitalTransfer1TourSideBar'].start(1)
        } else if (
          this.gt_OrbitTransferParam1.orbitsTourDone &&
          this.$router.currentRoute.path === '/analyticalorbit'
        ) {
          this.$tours['paramOrbitalTransfer1TourSideBar'].start(2)
          this.gt_OrbitTransferParam1.secondSideNavTourDone = true
        }
      }
    },
    changeRoute(link) {
      this.$router.push({ path: link.path })
      this.currentPath = this.$router.currentRoute.path
    },
    getPathId(link) {
      return link.path.slice(1, link.path.length)
    },
    getItems() {
      if (this.currentMission == null) {
        return []
      } else if (this.currentMission.typeName === 'SimulationRequest') {
        this.currentPath = this.$router.currentRoute.path
        let paths = []
        if (this.currentMission.type === 'Simulator') {
          paths.push({
            title: 'Simulator',
            path: '/numericalsimulatormission',
            icon: 'cog'
          })
          if (this.currentMission.name !== '') {
            paths.push({
              title: 'Dashboard',
              path: '/numericaldashboard',
              icon: 'chart-line'
            })
          }
          // TODO WIP results / dashboard ?
        } else if (this.currentMission.type === 'Formation flying') {
          paths.push({
            title: 'Formation flying definition',
            path: '/formationflyingsimulationrequest',
            icon: 'cog'
          })
          if (this.currentMission.name !== '') {
            // not a temp mission
            paths.push({
              title: 'Dashboard',
              path: '/formationflyingsimulationdashboard',
              icon: 'chart-line'
            })
          }
          return paths
        } else if (this.currentMission.type === 'Inspection mission') {
          paths.push({
            title: 'Inspection mission definition',
            path: '/inspectionsimulationrequest',
            icon: 'cog'
          })
          if (this.currentMission.name !== '') {
            // not a temp mission
            paths.push({
              title: 'Dashboard',
              path: '/inspectionsimulationdashboard',
              icon: 'chart-line'
            })
          }
          return paths
        } else {
          paths.push({
            title: 'Mission configuration',
            path: '/numericalmission',
            icon: 'cog'
          })
          if (this.currentMission.name !== '') {
            // not a temp mission
            paths.push({
              title: 'Dashboard',
              path: '/numericaldashboard',
              icon: 'chart-line'
            })
            paths.push({
              title: 'Compare with another mission',
              path: '/numericalcomparison',
              icon: 'object-ungroup'
            })
            if (
              this.currentResultsLog &&
              this.currentResultsLog.results &&
              this.currentResultsLog.results.threedEphemerides
            ) {
              paths.push({ title: '3D', path: '/numerical3d', icon: 'cubes' })
            }
          }
        }
        paths.push({
          title: 'Spacecraft',
          path: '/numericalspacecraft',
          icon: 'satellite'
        })
        paths.push({
          title: 'Shape',
          path: '/numericalspacecraftgeometry',
          icon: 'ruler-combined'
        })
        paths.push({
          title: 'Reaction wheel',
          path: '/reactionwheeldefinition',
          icon: 'sync'
        })
        paths.push({
          title: 'Battery',
          path: '/numericalbatterydefinition',
          icon: 'car-battery'
        })
        paths.push({
          title: 'Antenna',
          path: '/numericalantennadefinition',
          icon: 'broadcast-tower'
        })
        paths.push({
          title: 'Payload',
          path: '/analyticalconstellationpayload',
          icon: 'camera-retro'
        })
        paths.push({
          title: 'Ground station',
          path: '/analyticalconstellationgroundstation',
          icon: 'satellite-dish'
        })
        paths.push({
          title: 'Earth mesh',
          path: '/analyticalconstellationearthmesh',
          icon: 'atlas'
        })
        paths.push({
          title: 'Propulsion system',
          path: '/numericalthruster',
          icon: 'regular/dot-circle'
        })
        paths.push({ title: 'Orbit', path: '/numericalorbit', icon: 'globe' })
        return paths
      } else if (
        this.currentMission.typeName === 'ManeuverRestitutionRequest'
      ) {
        this.currentPath = this.$router.currentRoute.path
        let paths = []
        paths.push({
          title: 'Maneuver Restitution',
          path: '/maneuverrestitutionrequest',
          icon: 'cog'
        })
        if (this.currentMission.name !== '') {
          paths.push({
            title: 'Dashboard',
            path: '/maneuverrestitutiondashboard',
            icon: 'chart-line'
          })
        }
        paths.push({
          title: 'Space Object',
          path: '/spaceobject',
          icon: 'crosshairs'
        })
        paths.push({
          title: 'Spacecraft',
          path: '/numericalspacecraft',
          icon: 'satellite'
        })
        paths.push({
          title: 'Shape',
          path: '/numericalspacecraftgeometry',
          icon: 'ruler-combined'
        })
        paths.push({
          title: 'Reaction wheel',
          path: '/reactionwheeldefinition',
          icon: 'sync'
        })
        paths.push({
          title: 'Battery',
          path: '/numericalbatterydefinition',
          icon: 'car-battery'
        })
        paths.push({
          title: 'Antenna',
          path: '/numericalantennadefinition',
          icon: 'broadcast-tower'
        })
        paths.push({
          title: 'Payload',
          path: '/analyticalconstellationpayload',
          icon: 'camera-retro'
        })
        paths.push({
          title: 'Ground station',
          path: '/analyticalconstellationgroundstation',
          icon: 'satellite-dish'
        })
        paths.push({
          title: 'Earth mesh',
          path: '/analyticalconstellationearthmesh',
          icon: 'atlas'
        })
        paths.push({
          title: 'Propulsion system',
          path: '/numericalthruster',
          icon: 'regular/dot-circle'
        })
        paths.push({ title: 'Orbit', path: '/numericalorbit', icon: 'globe' })
        return paths
      } else if (
        this.currentMission.typeName === 'ManeuverCatalogueAnalysisRequest'
      ) {
        this.currentPath = this.$router.currentRoute.path
        let paths = []
        paths.push({
          title: 'Maneuver Analysis',
          path: '/maneuveranalysisrequest',
          icon: 'cog'
        })
        if (this.currentMission.name !== '') {
          paths.push({
            title: 'Dashboard',
            path: '/maneuveranalysisdashboard',
            icon: 'chart-line'
          })
        }
        paths.push({
          title: 'Space Object',
          path: '/spaceobject',
          icon: 'crosshairs'
        })
        paths.push({
          title: 'Database Management',
          path: '/maneuveranalysisdata',
          icon: 'database'
        })

        return paths
      } else if (this.currentMission.typeName === 'DataGeneratorRequest') {
        this.currentPath = this.$router.currentRoute.path
        let paths = []
        paths.push({
          title: 'Data Generator',
          path: '/datageneratorrequest',
          icon: 'cog'
        })
        if (this.currentMission.name !== '') {
          paths.push({
            title: 'Dashboard',
            path: '/datageneratordashboard',
            icon: 'chart-line'
          })
        }
        paths.push({
          title: 'Space Object',
          path: '/spaceobject',
          icon: 'crosshairs'
        })
        paths.push({ title: 'Orbit', path: '/numericalorbit', icon: 'globe' })
        paths.push({
          title: 'Database Management',
          path: '/maneuveranalysisdata',
          icon: 'database'
        })

        return paths
      } else if (this.currentMission.typeName === 'EvasiveManeuverRequest') {
        this.currentPath = this.$router.currentRoute.path
        let paths = []
        paths.push({
          title: 'Evasive Maneuver',
          path: '/evasivemaneuverrequest',
          icon: 'cog'
        })
        if (this.currentMission.name !== '') {
          paths.push({
            title: 'Dashboard',
            path: '/evasivemaneuverdashboard',
            icon: 'chart-line'
          })
          paths.push({
            title: 'Custom Evasive Scenarios',
            path: '/customevasivescenario',
            icon: 'database'
          })
        }
        paths.push({
          title: 'Space Object',
          path: '/spaceobject',
          icon: 'crosshairs'
        })
        paths.push({
          title: 'Orbits',
          path: '/numericalorbit',
          icon: 'globe'
        })
        return paths
      } else if (
        this.currentMission.typeName === 'ScreeningCatalogueAnalysisRequest'
      ) {
        this.currentPath = this.$router.currentRoute.path
        let paths = []
        paths.push({
          title: 'Dashboard',
          path: '/screeningcatalogueanalysisreactivedashboard',
          icon: 'chart-line'
        })
        paths.push({
          title: 'Space object group',
          path: '/spaceobjectgroup',
          icon: 'satellite'
        })
        paths.push({
          title: 'Alert definition',
          path: '/abstractalertdefinition',
          icon: 'globe'
        })
        return paths
      } else if (
        this.currentMission.typeName ===
        'ConstellationPerformanceAnalysisRequest'
      ) {
        this.currentPath = this.$router.currentRoute.path
        let paths = []
        paths.push({
          title: 'Configuration',
          path: '/analyticalconstellationsimulation',
          icon: 'cog'
        })
        if (this.currentMission.name !== '') {
          // not a temp mission
          paths.push({
            title: 'Dashboard',
            path: '/analyticalconstellationdashboard',
            icon: 'chart-line'
          })
          paths.push({
            title: 'Compare with another constellation',
            path: '/constellationcomparison',
            icon: 'object-ungroup'
          })
        }
        paths.push({
          title: 'Constellation',
          path: '/analyticalconstellationheterogeneous',
          icon: 'brands/react'
        })
        paths.push({
          title: 'Constellation geometry',
          path: '/analyticalconstellationhomogeneousgeometry',
          icon: 'pencil-ruler'
        })
        paths.push({
          title: 'Earth mesh',
          path: '/analyticalconstellationearthmesh',
          icon: 'atlas'
        })
        paths.push({
          title: 'Payload',
          path: '/analyticalconstellationpayload',
          icon: 'camera-retro'
        })
        paths.push({
          title: 'Ground station',
          path: '/analyticalconstellationgroundstation',
          icon: 'satellite-dish'
        })
        return paths
      } else if (
        this.currentMission.typeName === 'ConstellationOptimizationRequest'
      ) {
        this.currentPath = this.$router.currentRoute.path
        let paths = []
        paths.push({
          title: 'Configuration',
          path: '/constellationrevisitoptimizationmission',
          icon: 'cog'
        })
        if (this.currentMission.name !== '') {
          // not a temp mission
          paths.push({
            title: 'Dashboard',
            path: '/constellationrevisitoptimizationdashboard',
            icon: 'chart-line'
          })
        }
        paths.push({
          title: 'Constellation',
          path: '/analyticalconstellationheterogeneous',
          icon: 'brands/react'
        })
        paths.push({
          title: 'Constellation geometry',
          path: '/analyticalconstellationhomogeneousgeometry',
          icon: 'pencil-ruler'
        })
        paths.push({
          title: 'Zone of interest',
          path: '/analyticalconstellationearthzoneofinterest',
          icon: 'map-marked-alt'
        })
        paths.push({
          title: 'Point of interest',
          path: '/analyticalconstellationearthpointofinterest',
          icon: 'map-marker-alt'
        })
        paths.push({
          title: 'Earth mesh',
          path: '/analyticalconstellationearthmesh',
          icon: 'atlas'
        })
        paths.push({
          title: 'Payload',
          path: '/analyticalconstellationpayload',
          icon: 'camera-retro'
        })
        paths.push({
          title: 'Spacecraft',
          path: '/analyticalspacecraft',
          icon: 'satellite'
        })
        paths.push({
          title: 'Propulsion system',
          path: '/analyticalthruster',
          icon: 'regular/dot-circle'
        })
        return paths
      } else if (
        this.currentMission.typeName === 'EarthMoonTrajectoryRequest'
      ) {
        this.currentPath = this.$router.currentRoute.path
        let paths = []
        paths.push({
          title: 'Trajectories',
          path: '/earthmoontrajectoryrequest',
          icon: 'cog'
        })
        if (this.currentMission.name !== '') {
          // not a temp mission
          paths.push({
            title: 'Dashboard',
            path: '/earthmoontrajectorydashboard',
            icon: 'chart-line'
          })
        }
        return paths
      } else if (
        this.currentMission.typeName === 'ConstellationGenerationRequest'
      ) {
        this.currentPath = this.$router.currentRoute.path
        let paths = []
        paths.push({
          title: 'Configuration',
          path: '/constellationgenerationmission',
          icon: 'cog'
        })
        if (this.currentMission.name !== '') {
          // not a temp mission
          paths.push({
            title: 'Dashboard',
            path: '/constellationgenerationdashboard',
            icon: 'chart-line'
          })
        }
        paths.push({
          title: 'Constellation',
          path: '/analyticalconstellationheterogeneous',
          icon: 'brands/react'
        })
        paths.push({
          title: 'Constellation geometry',
          path: '/analyticalconstellationhomogeneousgeometry',
          icon: 'pencil-ruler'
        })
        paths.push({
          title: 'Zone of interest',
          path: '/analyticalconstellationearthzoneofinterest',
          icon: 'map-marked-alt'
        })
        paths.push({
          title: 'Point of interest',
          path: '/analyticalconstellationearthpointofinterest',
          icon: 'map-marker-alt'
        })
        paths.push({
          title: 'Earth mesh',
          path: '/analyticalconstellationearthmesh',
          icon: 'atlas'
        })
        paths.push({
          title: 'Payload',
          path: '/analyticalconstellationpayload',
          icon: 'camera-retro'
        })
        return paths
      } else if (this.currentMission.typeName === 'ParametricStudyRequest') {
        this.currentPath = this.$router.currentRoute.path
        let paths = []
        paths.push({
          title: 'Mission configuration',
          path: '/analyticalmission',
          icon: 'cog'
        })
        if (this.currentMission.name !== '') {
          // not a temp mission
          paths.push({
            title: 'Dashboard',
            path: '/analyticaldashboard',
            icon: 'chart-line'
          })
        }
        paths.push({
          title: 'Spacecraft',
          path: '/analyticalspacecraft',
          icon: 'satellite'
        })
        paths.push({
          title: 'Propulsion system',
          path: '/analyticalthruster',
          icon: 'regular/dot-circle'
        })
        paths.push({
          title: 'Magnetic torquer',
          path: '/analyticalmagnetictorquer',
          icon: 'magnet'
        })
        paths.push({
          title: 'Reaction wheel',
          path: '/reactionwheeldefinition',
          icon: 'sync'
        })
        paths.push({
          title: 'Sensor',
          path: '/analyticalsensor',
          icon: 'camera-retro'
        })
        paths.push({ title: 'Orbit', path: '/analyticalorbit', icon: 'globe' })
        return paths
      } else if (this.currentMission.typeName === 'DeploymentRequest') {
        this.currentPath = this.$router.currentRoute.path
        let paths = []
        paths.push({
          title: 'Configuration',
          path: '/deploymentmission',
          icon: 'cog'
        })
        if (this.currentMission.name !== '') {
          // not a temp mission
          paths.push({
            title: 'Dashboard',
            path: '/deploymentdashboard',
            icon: 'chart-line'
          })
        }
        paths.push({
          title: 'Launch',
          path: '/deploymentlaunch',
          icon: 'rocket'
        })
        paths.push({ title: 'Orbit', path: '/analyticalorbit', icon: 'globe' })
        paths.push({
          title: 'Constellation',
          path: '/analyticalconstellationheterogeneous',
          icon: 'brands/react'
        })
        paths.push({
          title: 'Constellation geometry',
          path: '/analyticalconstellationhomogeneousgeometry',
          icon: 'pencil-ruler'
        })
        paths.push({
          title: 'Spacecraft',
          path: '/analyticalspacecraft',
          icon: 'satellite'
        })
        paths.push({
          title: 'Magnetic torquer',
          path: '/analyticalmagnetictorquer',
          icon: 'magnet'
        })
        paths.push({
          title: 'Reaction wheel',
          path: '/reactionwheeldefinition',
          icon: 'sync'
        })
        paths.push({
          title: 'Sensor',
          path: '/analyticalsensor',
          icon: 'camera-retro'
        })
        paths.push({
          title: 'Propulsion system',
          path: '/analyticalthruster',
          icon: 'regular/dot-circle'
        })
        return paths
      } else if (
        this.currentMission.typeName === 'ConstellationSimulationRequest'
      ) {
        this.currentPath = this.$router.currentRoute.path
        let paths = []
        paths.push({
          title: 'Configuration',
          path: '/numericalconstellationmission',
          icon: 'cog'
        })
        if (this.currentMission.name !== '') {
          // not a temp mission
          paths.push({
            title: 'Dashboard',
            path: '/numericalconstellationdashboard',
            icon: 'chart-line'
          })
        }
        paths.push({
          title: 'Constellation',
          path: '/analyticalconstellationheterogeneous',
          icon: 'brands/react'
        })
        paths.push({
          title: 'Constellation geometry',
          path: '/analyticalconstellationhomogeneousgeometry',
          icon: 'pencil-ruler'
        })
        paths.push({
          title: 'Spacecraft',
          path: '/numericalspacecraft',
          icon: 'satellite'
        })
        paths.push({
          title: 'Shape',
          path: '/numericalspacecraftgeometry',
          icon: 'ruler-combined'
        })
        paths.push({
          title: 'Reaction wheel',
          path: '/reactionwheeldefinition',
          icon: 'sync'
        })
        paths.push({
          title: 'Battery',
          path: '/numericalbatterydefinition',
          icon: 'car-battery'
        })
        paths.push({
          title: 'Propulsion system',
          path: '/numericalthruster',
          icon: 'regular/dot-circle'
        })
        paths.push({
          title: 'Antenna',
          path: '/numericalantennadefinition',
          icon: 'broadcast-tower'
        })
        paths.push({
          title: 'Payload',
          path: '/analyticalconstellationpayload',
          icon: 'camera-retro'
        })
        paths.push({
          title: 'Ground station',
          path: '/analyticalconstellationgroundstation',
          icon: 'satellite-dish'
        })
        paths.push({
          title: 'Earth mesh',
          path: '/analyticalconstellationearthmesh',
          icon: 'atlas'
        })
        paths.push({
          title: 'Point of interest',
          path: '/analyticalconstellationearthpointofinterest',
          icon: 'map-marker-alt'
        })

        return paths
      } else {
        return []
      }
    }
  }
}
</script>

<style scoped>
.tile {
  padding: 5px;
}
.tile-darkMode {
  padding: 5px;
}
.tile:hover {
  background: #e0e0e0;
}
.text {
  background: transparent;
  font-size: 19px;
  font-weight: 300;
  color: darkgrey;
}
.selectedItem {
  color: #5757ff;
  font-weight: 400;
}

.avatar {
  min-width: 40px;
}

#side-bar {
  z-index: 7;
}

.button-open {
  animation-name: translate-60;
  -webkit-animation-name: translate-60;
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
  animation-duration: 0.5s;
  -webkit-animation-duration: 0.5s;
}

.button-close {
  animation-name: translate-200;
  -webkit-animation-name: translate-200;
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
  animation-duration: 0.5s;
  -webkit-animation-duration: 0.5s;
}

@keyframes translate-60 {
  to {
    transform: translateX(60px);
  }
}

@keyframes translate-200 {
  to {
    transform: translateX(250px);
  }
}

.button {
  padding-right: 2px;
  margin-top: 15px !important;
  min-width: 55px !important;
}

#drawer:hover .animation {
  display: block !important;
  position: absolute;
  z-index: 6;
}

.long-list-margin {
  margin-left: 0.72em;
}

.name-width {
  width: 133px;
}

.no-padding {
  padding: 0;
}

.position-center {
  left: 5px;
}
</style>
